import React from "react";
import startCase from "lodash/startCase";
import { AccessRequestStatus, IAccessRequestEntity } from "models/AccessRequest.model";
import { CellContext } from "@tanstack/react-table";
import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = CellContext<IAccessRequestEntity, any>;

const AccessRequestStatusChip: React.FC<Props> = ({
  row: {
    original: { status },
  },
}) => {
  const { t } = useTranslation();
  const label = React.useMemo(() => {
    if (status === AccessRequestStatus.Denied) {
      return t("Declined");
    }

    return startCase(status.toLowerCase());
  }, [t, status]);

  const color = React.useMemo(() => {
    switch (status) {
      case AccessRequestStatus.Approved:
        return "green";
      case AccessRequestStatus.Denied:
        return "red";
      case AccessRequestStatus.Expired:
        return "yellow";
      case AccessRequestStatus.Pending:
      default:
        return "default";
    }
  }, [status]);

  return <Chip variant={"filled"} label={label} color={color} />;
};

export default AccessRequestStatusChip;
